var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"textcontent",domProps:{"innerHTML":_vm._s(_vm.ksxz)}}),_vm._v(" "),_c('van-checkbox',{staticStyle:{"margin-top":"20px","margin-left":"30px"},attrs:{"shape":"square"},on:{"click":_vm.xuanzhong},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}},[_vm._v("确认考试协议")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ba1c082","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/kaoshi/ksxz.vue
// module id = null
// module chunks = 